import React from "react";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { UIProvider } from "./UIContext";
import { AuthProvider, useAuth } from "./AuthContext";
import { usePlantState } from "./hooks";
import Login from "./screens/Login";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";

import PlantValueCenter from "./screens/PlantValueCenter";
import OperationsCenter from "./screens/OperationsCenter";
import TwinDetail from "./screens/TwinDetail";
import ResourceIntelligence from "./screens/ResourceIntelligence";
import SustainabilityCenter from "./screens/SustainabilityCenter";
import OpportunityCenter from "./screens/OpportunityCenter";
import AIAdvisor from "./screens/AIAdvisor";
import SimulationStudio from "./screens/SimulationStudio";

function Shell() {
  const { state, refresh } = usePlantState(2000);
  return (
    <div className="oim-app" data-testid="oim-app">
      <Sidebar />
      <Header state={state} />
      <main className="oim-main">
        <Routes>
          <Route index path="/" element={<PlantValueCenter state={state} />} />
          <Route path="/operations" element={<OperationsCenter />} />
          <Route path="/operations/:key" element={<TwinDetail />} />
          <Route path="/resources" element={<ResourceIntelligence />} />
          <Route path="/sustainability" element={<SustainabilityCenter />} />
          <Route path="/opportunities" element={<OpportunityCenter />} />
          <Route path="/advisor" element={<AIAdvisor />} />
          <Route path="/simulation" element={<SimulationStudio state={state} refresh={refresh} />} />
        </Routes>
      </main>
      <footer className="oim-footer" data-testid="copyright-footer">
        © 2026, Saarv Solutions Private Limited. All Rights Reserved.
      </footer>
    </div>
  );
}

function Gate() {
  const { ready, isAuthed } = useAuth();
  if (!ready) return <div className="login-screen" data-testid="auth-loading" />;
  if (!isAuthed) return <Login />;
  return <Shell />; // mounts (and starts polling) only once authenticated
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UIProvider>
          <Gate />
        </UIProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
